import Vue from "vue";

const state = Vue.observable({
  visible: false,
  message: "",
  type: "success"
});

let timer = null;

function hide() {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  state.visible = false;
}

function show(message, type = "success", duration = 3000) {
  const text = String(message || "").trim();
  if (!text) {
    return;
  }

  if (timer) {
    clearTimeout(timer);
    timer = null;
  }

  state.visible = true;
  state.message = text;
  state.type = type === "error" ? "error" : "success";

  timer = setTimeout(() => {
    state.visible = false;
    timer = null;
  }, duration);
}

const toast = {
  state,
  show,
  hide,
  success(message, duration = 3000) {
    show(message, "success", duration);
  },
  error(message, duration = 3000) {
    show(message, "error", duration);
  }
};

export default toast;
